var stickyClass = 'loc-atcsticky';
var buttonClass = $('.purchase-details');
var elementPosition = buttonClass.offset();

$(window).scroll(function() {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height() - 100;
    const elementHeight = buttonClass.height();

    if (scrollTop > elementPosition.top || scrollTop + windowHeight < elementPosition.top + elementHeight) {
        buttonClass
            .css({
                'position': 'fixed',
                'bottom': '0'
            })
            .addClass(stickyClass);
    } else {
         buttonClass
            .css('position', 'static')
            .removeClass(stickyClass);
    }
});
